import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { Box, styled } from "@mui/system";
import { FC, useState } from "react";
import useCommonContext from "../../hooks/useCommonContext";
import muiIcons from "../icons/mui-icons";
import { H5, Paragraph, Span } from "../Typography";
import { GullButton } from "../buttons/GullButton";
import ProfileFormModal from "../modals/ProfileFormModal";

const ProfileDetails = styled(Accordion)(() => ({
  "&::before": {
    display: "none",
  },
}));

const DetailsBox = styled(Box)(() => ({
  margin: ".8rem 0rem",
}));

const UserTitle = styled(Span)(({ theme }) => ({
  fontSize: 12,
  fontWeight: 600,
  padding: "5px 10px",
  borderRadius: "5px",
  color: theme.palette.primary.main,
  background: theme.palette.primary[50],
}));

const AccordionController = styled(Span)(({ theme }) => ({
  fontSize: 12,
  fontWeight: 600,
  padding: "5px 10px",
  borderRadius: "5px",
  color: theme.palette.primary.main,
  background: theme.palette.primary[50],
  "& svg": {
    fontSize: 12,
    marginLeft: "5px",
    marginBottom: "-2px",
  },
}));

const ProfileAccordion: FC = () => {
  const { setFormModal } = useCommonContext();
  const { DownArrowIcon, UpArrowIcon } = muiIcons;
  const [expanded, setExpanded] = useState<boolean>(true);
  const handleAccordion = () => {
    expanded ? setExpanded(false) : setExpanded(true);
  };
  return (
    <ProfileDetails
      disableGutters
      expanded={expanded}
      onChange={handleAccordion}
    >
      <Box
        py="1rem"
        display="flex"
        justifyContent="space-between"
        borderBottom="1px dashed #e0e0e0"
      >
        <AccordionSummary sx={{ p: 0 }}>
          <AccordionController>
            Details
            {expanded ? <DownArrowIcon /> : <UpArrowIcon />}
          </AccordionController>
        </AccordionSummary>
        <GullButton
          color="primary"
          variant="contained"
          sx={{ p: ".1rem .6rem" }}
          onClick={() => setFormModal(true)}
        >
          Edit
        </GullButton>

        <ProfileFormModal />
      </Box>
      <AccordionDetails sx={{ pb: 0 }}>
        <Box mt="15px" mb="15px">
          <UserTitle>Premium user</UserTitle>
        </Box>
        <DetailsBox>
          <H5>Account ID</H5>
          ID-24562389
        </DetailsBox>
        <DetailsBox>
          <H5>Billing Email</H5>
          example.uilib@gmail.com
        </DetailsBox>
        <DetailsBox>
          <H5>Billing Address</H5>
          <Paragraph>
            522 Subidbazar Street, <br />
            Sylhet 3100 VIC <br />
            Bangladesh
          </Paragraph>
        </DetailsBox>
        <DetailsBox>
          <H5>Language</H5>
          English
        </DetailsBox>
        <DetailsBox>
          <H5>Upcoming Invoice</H5>
          98765-4323
        </DetailsBox>
        <DetailsBox>
          <H5>Tax ID</H5>
          TX-6732
        </DetailsBox>
      </AccordionDetails>
    </ProfileDetails>
  );
};

export default ProfileAccordion;
